import { useEffect, useState } from 'react';
// mantine
import { Loader, TextInput } from '@mantine/core';
import { useDebouncedState } from '@mantine/hooks';
// components
import NoRecords from '@/components/NoRecords';
import ProjectImagesList from '@/pages/VersionControl/components/Storages/components/ProjectImagesList';
import StorageSelect from '@/pages/VersionControl/components/Storages/components/StorageSelect';
// utils
import { useProjectImageStoragesQuery } from '@/services/designer/project_image_storages/project_image_storages.queries';

interface StoragesProps {
    isAdmin: boolean;
}

const DEBOUNCE_TIMEOUT = 500;

const Storages = ({ isAdmin }: StoragesProps) => {
    const [storageId, setStorageId] = useState<string | undefined>();
    const [searchTerm, setSearchTerm] = useDebouncedState('', DEBOUNCE_TIMEOUT);
    const {
        data: storages,
        isSuccess,
        isLoading
    } = useProjectImageStoragesQuery();

    useEffect(() => {
        if (storages?.length && !storageId) {
            setStorageId(storages[0].id);
        }
    }, [storages, storageId]);

    return (
        <div className="flex flex-col gap-4">
            <div className="flex gap-4">
                <StorageSelect
                    className="flex-1 max-w-sm"
                    label="Storage"
                    storages={storages ?? []}
                    value={storageId}
                    onChange={setStorageId}
                />
                <TextInput
                    className="flex-1 max-w-sm"
                    label="Search"
                    placeholder="Search by idn"
                    size="xs"
                    onChange={(event) => {
                        setSearchTerm(event.target.value);
                    }}
                />
            </div>
            {isLoading ? (
                <div className="flex justify-center items-center py-8">
                    <Loader size={24} />
                </div>
            ) : undefined}
            {isSuccess && storages.length === 0 ? <NoRecords /> : undefined}
            {storageId ? (
                <ProjectImagesList
                    isAdmin={isAdmin}
                    searchTerm={searchTerm}
                    storageId={storageId}
                />
            ) : undefined}
        </div>
    );
};

export default Storages;
